<!DOCTYPE html>
<html lang="en">

  <head>
    <title>SBLOC Email</title>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" type="image/png" href="https://fispoke-dev.firstrate-wealthtech.com/assets/images/favicon.ico" />
    <link rel="stylesheet" type="text/css"
      href="https://fispoke-dev.firstrate-wealthtech.com/assets/auth-login/css/util.css" />
    <link rel="stylesheet" type="text/css"
      href="https://fispoke-dev.firstrate-wealthtech.com/assets/auth-login/css/main.css" />
    <link href="https://cdnjs.cloudflare.com/ajax/libs/primeicons/3.0.0/primeicons.min.css" rel="stylesheet"
      type="text/css" />
    <link rel="stylesheet" type="text/css"
      href="https://fispoke-dev.firstrate-wealthtech.com/assets/auth-login/css/custom-login.css"
      data-preload="true" />

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />

    <style>
      body {
      background-color: #f7f7f7;
    }

    .card {
    /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3) !important; */
  }

  .card-header {
  background: linear-gradient(to bottom, #01205f, #04b0ea);
  /* border-top-left-radius: 1rem !important; */
  top: -18px !important;
  border-radius: 8px !important;
  left: -10px !important;
  border-color: #01205f !important;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.3);
}

.text-primary {
color: #01205f !important;
}
.text-success {
color: #4caf50 !important;
}

/* Base button styles */
.custom-button {
padding: 0.5rem 1rem;
font-size: 1rem;
font-weight: bold;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s ease, transform 0.2s ease;
border: none;
display: inline-flex;
align-items: center;
justify-content: center;
}

/* Label inside the button */
.button-label {
color: inherit;
}

/* Primary button (Accept) */
.custom-button.primary {
background-color: #01205f !important;
color: #ffffff !important;
}

.custom-button.primary:hover {
background-color: #014288 !important;
/* transform: translateY(-2px); */
}

/* Danger button (Reject) outlined */
.custom-button.outlined.danger {
background-color: transparent !important;
color: #dc3545 !important;
border: 1px solid #dc3545 !important;
}

.custom-button.outlined.danger:hover {
background-color: rgba(220, 53, 69, 0.1) !important;
/* transform: translateY(-2px); */
}

/* Optional: focus styles */
.custom-button:focus {
outline: 1px solid #01205f !important;
outline: 0 !important;
}
.custom-button.outlined.danger:focus {
border: 1px solid #dc3545 !important;
outline: 0 !important;
}
/* Disabled style (if needed) */
.custom-button:disabled {
background-color: #cccccc !important;
color: #777777 !important;
cursor: not-allowed;
}
</style>

<!--===============================================================================================-->
</head>

<body>
  <div class="container mt-4 pt-4">
    <div class="row d-flex align-item-center justify-content-center">
      <div class="col-9">
        <!-- <img src="https://fispoke-dev.firstrate-wealthtech.com/assets/auth-login/images/Sanctuary_Wealth_Logo.jpg"
        class="my-4 mb-5" /> -->
        <!-- <img
        *ngIf="withdrawCashMomentData?.RecipientDetails?.FirmLogo"
        [src]="withdrawCashMomentData?.RecipientDetails?.FirmLogo"
        />
      <img
        *ngIf="withdrawCashMomentData?.SenderDetails?.FirmLogo"
        [src]="withdrawCashMomentData?.SenderDetails?.FirmLogo"
        /> -->
        <!-- <p class="text-center text-primary fs-4 fw-medium">Accept or Reject</p> -->
        <div class="card p-3 position-relative rounded-4 shadow-sm mx-3 mt-5">
          <div class="card-header text-white position-absolute top-0 start-0 border-0 py-2 pe-5 fs-14">
            Security Based Lending Proposal
          </div>
          <div class="card-body mt-3">
            @if (isNormalMessageVisible) {
              <p class="text-center text-primary fs-6 mb-0">You’ve been invited
                to respond to a security-based lending proposal. Please review the information received in
              the email carefully and indicate your decision below to proceed.</p>
            }
            @if (isAcceptMessageVisble) {
              <p class="text-center text-success  fs-6 mb-0">Thank you for
                accepting the proposal. We are currently waiting for all other pledgers and borrowers to
                accept the proposal in order to proceed with the application process for this security-based
              lending proposal.</p>
            }
            @if (isRejectMessageVisble) {
              <p class="text-center text-danger fs-6 mb-0">You have declined the
                proposal. This proposal will no longer proceed with the security-based lending process. If
              this was an error, please contact your advisor.</p>
            }
            <hr />
            <div class="flex flex-column">
              <!-- <p-divider align="left" type="dotted" class="m-0">
              <span class="font-14 text-color-secondary">Details</span>
            </p-divider> -->
            <!-- <div class="flex align-items-center justify-content-left gap-2 mb-3 mt-2">
            <div class="flex-1 flex-grow align-items-center justify-content-left">
              <label class="form-label">Proposal Number : 100000</label>
              <label class="font-regular mr-1"></label>
            </div>
            <div class="flex-1 flex-grow align-items-center justify-content-left">
              <label class="form-label">Desired Line of Credit : $200,000</label>
              <label class="font-regular mr-1"></label>
            </div>
          </div> -->
        </div>



        <!-- <hr/> -->
        <div class="flex align-items-center justify-content-center gap-2 mt-3">
          <!-- Accept Button -->
          <button class="custom-button primary" type="button" (click)="acceptPraposal()">
            <span class="button-label">Accept</span>
          </button>

          <!-- Reject Button -->
          <button class="custom-button outlined danger" type="button" (click)="rejectPraposal()">
            <span class="button-label">Reject</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
</div>

<!--===============================================================================================-->
<script src="vendor/jquery/jquery-3.2.1.min.js"></script>
<!--===============================================================================================-->
<script src="js/main.js"></script>
<!--===============================================================================================-->
</body>

</html>